import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { TimezoneProvider } from "./components/timeZone";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";

import { ReactNotifications } from "react-notifications-component";
import { ErrorBoundary } from "react-error-boundary";
import whiteScreenFallback from "./screens/error-screens/white-screen-fallback";

import { ConfigProvider, theme } from 'antd';
import "./i18next";
import { MenuProvider } from "./MenuProvider";
import { getBaseName } from "./utils/getFile";
import { useEffect } from "react";



const ThemedApp = () => {

  const { theme: customTheme, updateTheme } = useTheme();

  const basename = getBaseName();




  useEffect(() => {
    if (basename && !basename.includes('portal')) {

      try {
        const config = require('./clients-data' + basename + '/theme.json');

        if (config) {
          updateTheme(config);
        }

      } catch {
        console.log("Could not load custom theme");
      }

    }
  }, [basename]);


  return (
    <ConfigProvider theme={{
      // algorithm : darkAlgorithm,
      token: {
        colorPrimary: customTheme.colorPrimary,
        colorBgContainer: "#fff",
        fontFamily: customTheme.font,
        colorBorder: customTheme.colorPrimary,
        colorBgBase: " #f2f2f2",
        colorLink: customTheme.colorPrimary,
        borderRadius: customTheme.borderRadius,
        colorError: "#cc0003"
      },
      components: {
        Button: {
          boxShadow: '0',
          primaryShadow: 'none',
          controlHeight: customTheme.inputHeight,
          padding: 12,
          lineWidth: 2,
          fontWeight: "600",
          borderColorDisabled: customTheme.colorPrimaryHalfOpacity,
          colorBgSolid: customTheme.colorPrimary,
          colorBgSolidActive: customTheme.colorPrimary,
          colorTextDisabled: customTheme.colorPrimaryHalfOpacity,
          colorText: customTheme.colorPrimary
        },
        Layout: {
          headerBg: '#fff',
          triggerHeight: 0,
          siderBg: "#f2f2f2"
        },
        Menu: {
          itemSelectedBg: customTheme.colorPrimaryHalfOpacity,
          itemPaddingInline: 8,
          colorIcon: "#403387"

        },
        Segmented: {
          itemSelectedBg: "#fff",
        },
        Select: {
          colorBorder: customTheme.colorPrimaryHalfOpacity,
          controlHeight: customTheme.inputHeight,
          colorBgElevated: "#fff",
          boxShadow: "none",
          activeOutlineColor: "none",
          activeBorderColor: customTheme.colorPrimary,
          optionSelectedBg: customTheme.colorPrimaryQuarterOpacity,
          colorBgBase: "#fff",
          colorTextDisabled: customTheme.colorPrimary
        },
        DatePicker: {
          controlHeight: customTheme.inputHeight,
          colorBorder: customTheme.colorPrimaryHalfOpacity,
          colorBgBase: "#fff",
          colorBgElevated: "#fff",
          colorBgContainer: "#fff",
          colorBgContainerDisabled: "#f2f2f2",
          colorTextDisabled: customTheme.colorPrimary
        },
        Calendar: {
          // colorBgElevated: "#fff",
          // colorBgBase: "#fff",
          // colorBgContainer: "#fff",
          // colorBgContainerDisabled: "#fff",
          // colorBgContainerDisabled: "#fff",
          colorTextDisabled: customTheme.colorPrimary
        },
        Input: {
          controlHeight: customTheme.inputHeight,
          colorBorder: customTheme.colorPrimaryHalfOpacity,
          activeShadow: "none",
          colorBgBase: "#fff",
          colorBgElevated: "#fff",
          colorTextDisabled: customTheme.colorPrimary
        },
        InputNumber: {
          controlHeight: customTheme.inputHeight,
          activeShadow: "none",
          colorBgBase: "#fff",
          colorBgElevated: "#fff",
          colorTextDisabled: customTheme.colorPrimary
        },
        Table: {
          padding: 8,
          cellPaddingBlock: 8,
          cellPaddingInline: 8,
          headerColor: customTheme.colorPrimary,
          rowSelectedBg: customTheme.colorPrimaryQuarterOpacity
        },
        Popover: {
          colorBgContainer: "#fff",
          colorBgElevated: "#fff",
          colorBgBase: "#fff",
          colorText: customTheme.colorPrimary,
          colorBgSolidActive: "#fff",
          controlItemBgActive: "#fff"
        },
        Form: {
          itemMarginBottom: 8,
          verticalLabelPadding: 2,
          // labelColor: customTheme.colorPrimary
        },
        Modal: {
          colorBgContainer: "#fff",
          colorBgBase: "#fff",
          colorPrimary: customTheme.colorPrimary,
          colorPrimaryHover: customTheme.colorPrimary,
          colorPrimaryActive: customTheme.colorPrimary,
          colorPrimaryBorder: customTheme.colorPrimary,
          colorPrimaryBorderHover: customTheme.colorPrimary,
          colorPrimaryText: "#fff",
          colorPrimaryTextHover: "#fff",
          colorPrimaryTextActive: "#fff",
          colorBgElevated: "#fff",
        },
        Drawer: {
          colorText: customTheme.colorPrimary,
          padding: 16,
          paddingLG: 8,
        },
        Collapse: {
          colorBorder: "#fff"
        }
      }
    }}>
      <BrowserRouter basename={basename}>
        <MenuProvider>
          <Routes>
            <Route path="*" element={<App />}></Route>
            <Route path="*" element={<Navigate replace to="/login" />} />
            {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}

          </Routes>
        </MenuProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ErrorBoundary
    fallbackRender={whiteScreenFallback}
    onReset={() => {
      // Reset the state of your app so the error doesn't happen again
    }}
  >
    <TimezoneProvider>
      <ReactNotifications />
      <Provider store={store}>
        <ThemeProvider>
          <ThemedApp />
        </ThemeProvider>
      </Provider>
    </TimezoneProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
